// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__lf-i9","modalForm":"UpgradeEpcsModal_modalForm__tOVjM","modalFooter":"UpgradeEpcsModal_modalFooter__gO-Xf"};